module.exports = __webpack_public_path__ + "assets/seepoint.5e6dff81.svg";